import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: 16px;

  .title {
    color: ${colors.silver};
    font-size: 12px;
    font-weight: 600;
    margin: 16px 0 0 0;
  }

  .optionGroup {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;
